import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';
import { AudioVideoSubcategoryTypeEnum } from '../interfaces/audio-video.model';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.Writing,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Writing',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>These videos show you how you could answer some of your writing questions — we\'ve used our best handwriting especially!</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Writing Video Solutions',
        Intro:
          'Use these videos to help you find out how to approach some of the writing questions in your book.',
        LeftSections: [
          {
            Header: 'Section Two — Identity and Relationships with Others',
            Subcategories: [
              {
                Name: 'Describing People and Relationships — Q2 (Foundation)',
                ShortName: 'Describing-People-and-Relationships-Q2-Foundation',
                Link: 'https://www.youtube.com/embed/jm-AIDAbchk?rel=0&modestbranding=1',
              },
              {
                Name: 'Describing People and Relationships — Q2 (Higher)',
                ShortName: 'Describing-People-and-Relationships-Q2-Higher',
                Link: 'https://www.youtube.com/embed/PhsmnOZfG5Y?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Four — Education',
            Subcategories: [
              {
                Name: 'School Pressures and Difficulties — Q3',
                ShortName: 'School-Pressures-and-Difficulties-Q3',
                Link: 'https://www.youtube.com/embed/TVc3VoGSieQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Six — Free-time Activities',
            Subcategories: [
              {
                Name: 'Sport, Going Out and Other Hobbies — Q4',
                ShortName: 'Sport-Going-Out-and-Other-Hobbies-Q4',
                Link: 'https://www.youtube.com/embed/5Td6hHcBAjo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Nine — Travel and Tourism',
            Subcategories: [
              {
                Name: 'What to Do — Q4',
                ShortName: 'What-to-Do-Q4',
                Link: 'https://www.youtube.com/embed/XIqExR0Pp2w?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Ten — Media and Technology',
            Subcategories: [
              {
                Name: 'Technology and The Internet — Q3',
                ShortName: 'Technology-and-The-Internet-Q3',
                Link: 'https://www.youtube.com/embed/PDGeeIliyr0?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Reading,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Reading',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Watch us work through some of the reading questions in your book.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Reading Video Solutions',
        Intro:
          'Our experts work through some of the reading questions in your book — take your pick!',
        LeftSections: [
          {
            Header: 'Section Two — Identity and Relationships with Others',
            Subcategories: [
              {
                Name: 'About Yourself and My Family and Friends — Q2',
                ShortName: 'About-Yourself-and-My-Family-and-Friends-Q2',
                Link: 'https://www.youtube.com/embed/GtpuyE46r-g?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Theme 1 — Mixed Practice',
            Subcategories: [
              {
                Name: 'Theme 1 Mixed Practice Higher — Q6',
                ShortName: 'Theme-1-Mixed-Practice-Higher-Q6',
                Link: 'https://www.youtube.com/embed/s06wg8ZRxHs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eight — Celebrity Culture',
            Subcategories: [
              {
                Name: 'Favourite Celebrities and Celebrity Culture — Q3',
                ShortName: 'Favourite-Celebrities-and-Celebrity-Culture-Q3',
                Link: 'https://www.youtube.com/embed/7fVwP44bAXA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Nine — Travel and Tourism',
            Subcategories: [
              {
                Name: 'Where to Go, Accommodation and Travel — Q3',
                ShortName: 'Where-to-Go-Accommodation-and-Travel-Q3',
                Link: 'https://www.youtube.com/embed/r1EsXPV5QoA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Eleven — Where People Live',
            Subcategories: [
              {
                Name: 'Where You Live and The Home — Q2',
                ShortName: 'Where-You-Live-and-The-Home-Q2',
                Link: 'https://www.youtube.com/embed/MnZhhGOq_pk?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Twelve — Environmental and Social Issues',
            Subcategories: [
              {
                Name: 'Social Issues — Q3',
                ShortName: 'Social-Issues-Q3',
                Link: 'https://www.youtube.com/embed/Rv0o-PsU3nA?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro:   '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ListeningTracks,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Listening',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>You\'ve hit the listening jackpot — here\'s all the audio you\'ll need for your listening questions.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio for all listening questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Audio',
      Intro: 'Choose a listening question in your book and find the matching audio track below!',
      ProductTitle: 'GCSE AQA French Exam Practice Workbook',
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/01-listening-track-01-numbers-times-days-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/02-listening-track-02-numbers-times-days-and-dates.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/03-listening-track-03-questions-and-being-polite.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/04-listening-track-04-opinions.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/05-listening-track-05-about-yourself-and-my-family-&-friends.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/06-listening-track-06-describing-people-and-relationships.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/07-listening-track-07-food-and-healthy-&-unhealthy-living.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/08-listening-track-08-illnesses-and-treatments.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/09-listening-track-09-school-subjects-and-school-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/10-listening-track-10-school-pressures-and-difficulties.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/11-listening-track-11-education-post-16-and-career-choices.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/12-listening-track-12-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/13-listening-track-13-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/14-listening-track-14-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/15-listening-track-15-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/16-listening-track-16-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/17-listening-track-17-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/18-listening-track-18-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/19-listening-track-19-music-cinema-theatre-and-tv.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/20-listening-track-20-sport-going-out-and-other-hobbies.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/21-listening-track-21-customs-celebrations-and-festivals.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/22-listening-track-22-favourite-celebrities-&-celebrity-life.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/23-listening-track-23-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/24-listening-track-24-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/25-listening-track-25-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/26-listening-track-26-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/27-listening-track-27-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/28-listening-track-28-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/29-listening-track-29-where-to-go-accommodation-and-travel.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/30-listening-track-30-what-to-do.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/31-listening-track-31-technology-and-the-internet.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/32-listening-track-32-social-media.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/33-listening-track-33-where-you-live-and-the-home.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/34-listening-track-34-the-local-area-directions-and-weather.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/35-listening-track-35-protecting-the-environment-&-environmental-problems.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/36-listening-track-36-social-issues.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/37-listening-track-37-mixed-practice-foundation.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/38-listening-track-38-mixed-practice-both-tiers.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/39-listening-track-39-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/40-listening-track-40-mixed-practice-higher.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/41-listening-track-41-mixed-practice-highe.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/listening/42-listening-track-42-mixed-practice-higher.mp3',
      ],
      AdditionalInfo: '',
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Speaking,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to audio and videos',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Speaking',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>All the audio for your speaking questions and some example answers from our speaking pros — let\'s go!</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Audio and example answer videos',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        RightSections: [],
        Intro: '',
        Title: '',
        LeftSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    AudioVideo: {
      Intro:
        'Check out the audio for the speaking questions in your book or take a look at our handy videos, which give you some example answers.',
      Title: 'Speaking Audio and Video Solutions',
      LeftSections: [
        {
          Title: 'Speaking Audio',
          Header: '',
          Subcategories: [
            {
              Name: 'Audio Support',
              Link: '',
              LinkName: '',
              Description:
                'Choose a speaking question in your book and find the matching audio track below!',
              Type: AudioVideoSubcategoryTypeEnum.Audio,
              TrackFilePaths: [
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/01-speaking-track-01-food-and-healthy-&-unhealthy-living.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/02-speaking-track-02-school-subjects-and-school-life.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/03-speaking-track-03-education-post-16-and-career-choices.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/04-speaking-track-04-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/05-speaking-track-05-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/06-speaking-track-06-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/07-speaking-track-07-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/08-speaking-track-08-music-cinema-theatre-and-tv.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/09-speaking-track-09-customs-celebrations-and-festivals.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/10-speaking-track-10-favourite-celebrities-&-celebrity-life.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/11-speaking-track-11-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/12-speaking-track-12-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/13-speaking-track-13-mixed-practice-both-tiers.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/14-speaking-track-14-mixed-practice-higher.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/15-speaking-track-15-where-to-go-accommodation-and-travel.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/16-speaking-track-16-the-local-area-directions-and-weather.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/17-speaking-track-17-protecting-the-environment-&-environmental-problems.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/18-speaking-track-18-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/19-speaking-track-19-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/20-speaking-track-20-mixed-practice-foundation.mp3',
                '[[cloudfront_url]]/_revisionhub_opc/FAQ42/Audio/speaking/21-speaking-track-21-mixed-practice-higher.mp3',
              ],
            },
          ],
        },
        {
          Title: 'Speaking Video Solutions',
          Header: 'Theme 1 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Theme 1 Mixed Practice Higher — Q3',
              Link: 'https://www.youtube.com/embed/WxUVHXulJq0?rel=0&modestbranding=1',
              LinkName: 'theme1-q3',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Section Six — Free-time Activities',
          Subcategories: [
            {
              Name: 'Music, Cinema, Theatre and TV — Q1',
              Link: 'https://www.youtube.com/embed/hSiFGOyahBA?rel=0&modestbranding=1',
              LinkName: 'music-cinema-theatre-tv',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Theme 2 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Theme 2 Mixed Practice Foundation — Q4',
              Link: 'https://www.youtube.com/embed/d145sYv_LBk?rel=0&modestbranding=1',
              LinkName: 'theme2-q4',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
            {
              Name: 'Theme 2 Mixed Practice Higher — Q3',
              Link: 'https://www.youtube.com/embed/BDW_DGWT9AU?rel=0&modestbranding=1',
              LinkName: 'theme2-q3',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
        {
          Title: '',
          Header: 'Theme 3 — Mixed Practice',
          Subcategories: [
            {
              Name: 'Theme 3 Mixed Practice Foundation — Q7',
              Link: 'https://www.youtube.com/embed/mPBrr-34COw?rel=0&modestbranding=1',
              LinkName: 'theme3-q7',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
            {
              Name: 'Theme 3 Mixed Practice Higher — Q8',
              Link: 'https://www.youtube.com/embed/1cIzIIMUopI?rel=0&modestbranding=1',
              LinkName: 'theme3-q8',
              Description: '',
              Type: AudioVideoSubcategoryTypeEnum.Video,
              TrackFilePaths: [],
            },
          ],
        },
      ],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Get access with your book',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>All the audio you&rsquo;ll need to answer the listening questions in your book.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Printable answers, transcripts, and vocabulary lists — yep, it\'s all right here. </p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
      '<h3>Speaking</h3>\n'+
        '\n'+
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FAQ42/PDFs/cgp-gcse-french-speaking-transcripts-pdf.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Transcripts</a></p>\n'+
        '\n'+
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FAQ42/PDFs/cgp-gcse-french-speaking-mark-schemes_pdf.pdf" style="color: rgb(20, 148, 212);" target="_blank">Speaking Mark Schemes</a></p>\n'+
        '\n'+
        '<h3>Listening</h3>\n'+
        '\n'+
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FAQ42/PDFs/cgp-gcse-french-listening-transcripts.pdf" style="color: rgb(20, 148, 212);" target="_blank">Listening Transcripts</a></p>\n'+
        '\n'+
        '<h3>Writing</h3>\n'+
        '\n'+
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/FAQ42/PDFs/cgp-gcse-french-writing-mark-schemes-pdf.pdf" style="color: rgb(20, 148, 212);" target="_blank">Writing Mark Schemes</a></p>\n'+
        '\n'+
        '<p>&nbsp;</p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Writing',
        ImagePath: '/assets/images/landing/writing.png',
        DestinationPage: 'Writing',
      },
      {
        Text: 'Reading',
        ImagePath: '/assets/images/landing/reading.png',
        DestinationPage: 'Reading',
      },
      {
        Text: 'Listening',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Listening',
      },
      {
        Text: 'Speaking',
        ImagePath: '/assets/images/landing/q-a-audio.png',
        DestinationPage: 'Speaking',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'There\'s plenty more revision where this came from! Take a look at some of our other revision books.',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      AdditionalInfo: '',
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
